import React, { useRef } from "react";
import Draggable from "react-draggable";

import { XRayPageView } from "./XRayPageView";
import { XRayTooltipNewReturning } from "./XRayTooltipNewReturning";
import { XRayEmail } from "./XRayEmail";
import { XrayTooltipSharedLineChart } from "./XrayTooltipSharedLineChart";
import { XRayTooltipDonationVisits } from "./XRayTooltipDonationVisits";
import { XRayTooltipContentVelocity } from "./XRayTooltipContentVelocity";
import { XRayDonationsBarLineChart } from "./XRayDonationsBarLineChart";
import { XRayLineChartTooltip } from "./XRayLineChartTooltip";
import { XrayTooltipContent } from "./XrayTooltipTopContent";
import { XrayTooltipInsights } from "./XrayTooltipInsights";
import { XRayComparison } from "./XRayComparison";

export const XRayTooltip = (props) => {
  const { data, insights, close } = props;
  const extra = data.extra;
  const nodeRef = useRef(null);

  const hasTopContent = data.activePayload?.[0]?.payload?.topContent || false;
  const hasSharedLineChart = data.hasSharedLineChart;

  return (
    <Draggable
      handle=".xray-tooltip__drag"
      defaultPosition={{ x: 0, y: 0 }}
      position={null}
      grid={[5, 5]}
      scale={1}
      nodeRef={nodeRef}
    >
      <div ref={nodeRef} className="xray-tooltip">
        {data.indicator === "comparison" && (
          <XRayComparison data={data} close={close} />
        )}
        {data.indicator === "pageView" && (
          <XRayPageView data={data} close={close} />
        )}
        {data.indicator === "newReturning" && (
          <XRayTooltipNewReturning data={data} close={close} />
        )}
        {data.indicator === "emailPerformance" && (
          <XRayEmail data={data} close={close} />
        )}

        {data.indicator === "donationsBarLineChart" && (
          <XRayDonationsBarLineChart data={data} close={close} />
        )}

        {data.indicator === "donationsVisits" && (
          <XRayTooltipDonationVisits data={data} close={close} />
        )}

        {data.indicator === "contentVelocity" && (
          <XRayTooltipContentVelocity data={data} close={close} />
        )}

        {hasSharedLineChart && (
          <XrayTooltipSharedLineChart data={data} close={close} />
        )}

        {extra && (
          <XRayLineChartTooltip data={data} insights={insights} close={close} />
        )}

        {hasTopContent && (
          <XrayTooltipContent data={data} insights={insights} />
        )}
        {insights && <XrayTooltipInsights data={data} insights={insights} />}
      </div>
    </Draggable>
  );
};
